import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as EmailValidator from 'email-validator';
import moment from 'moment';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  // Button,
  RadioGroup,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DateSelect from '../../../components/DateSelect';
import Button from '../../../components/Button';
import PhoneInput from '../../../components/PhoneInput';
import { isEmailAvailable } from '../../../services/api';
import { STATES_LIST } from '../../../constants';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { fetchTebraInsurancesList } from '../../../services/api/admin';

const {
  standardizePhoneNumber,
} = require('../../../util/standardizePhoneNumber');

const validatePhone = num => {
  return num.replace(/[a-z\W]/gi, '').length === 10 && !/[a-z]/i.test(num);
};

function PortalProfileUpdate(props) {
  const {
    patient,
    updatePatient,
    onClose,
    // isDependent,
    // setFamily,
    classes: { input, dialogFooter },
  } = props;

  const [firstName, setFirstName] = useState(patient.firstName || '');
  const [lastName, setLastName] = useState(patient.lastName || '');
  const [preferredName, setPreferredName] = useState(patient.preferredName || '');
  const [email, setEmail] = useState(patient.email || '');
  const [phone, setPhone] = useState(
    standardizePhoneNumber(patient.phone) || ''
  );
  const [zipcode, setZipcode] = useState(patient.zipcode || '');
  const [gender, setGender] = useState(patient.gender || '');
  const [birthdate, setBirthdate] = useState(patient.birthdate || null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [emailError, setEmailError] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});
  const [addressLine1, setAddressLine1] = useState(patient.addressLine1 || '');
  const [addressLine2, setAddressLine2] = useState(patient.addressLine2 || '');
  const [city, setCity] = useState(patient.city || '');
  const [state, setState] = useState(patient.state || '');
  const [insurancePlans, setInsurancePlans] = useState([]);
  const [insurancePlanId, setInsurancePlanId] = useState(patient.insurancePlanId || null);
  const [insuranceId, setInsuranceId] = useState(patient.insuranceId || '');
  const [payerId, setPayerId] = useState(patient.payerId || '');
  const [groupNumber, setGroupNumber] = useState(patient.groupNumber || '');
  // const [subscribedEndDate, setSubscribedEndDate] = useState('');
  // const [isSubscribed, setIsSubscribed] = useState(false);

  // useEffect(() => {
  //   (async () => {
  // const amISubscribed = await checkSubscriptions();
  // setIsSubscribed(amISubscribed);
  // const subscribedEndDate = await fetchSubscriptedInfo();
  // setSubscribedEndDate(subscribedEndDate);
  //   })();
  // }, []);

  // These are insurances that has no group number.
  const insuranceWithoutGroupNumber = ['729d4056-09e9-4b3a-a37b-8a236bb154ab', '74a91228-6503-4851-922d-d4e23bc402ff', '1d1dae88-1d16-4e3b-a63d-a32e74a88e0a']

  useEffect(() => {
    (async () => {
      const response = await fetchTebraInsurancesList();
      setInsurancePlans(response.data);
    })();
  }, []);

  const onSubmit = async e => {
    e.preventDefault();
    if (validate()) {
      setButtonDisable(true);
      updatePatient({
        id: patient.id,
        userId: patient.userId,
        firstName,
        lastName,
        preferredName,
        email,
        phone,
        zipcode,
        gender,
        birthdate: moment(birthdate).format(),
        addressLine1,
        addressLine2,
        city,
        state,
        insurancePlanId,
        insuranceId,
        payerId,
        groupNumber
      });
      onClose();
    } else {
      console.log('Form has errors.');
    }
  };

  const validate = () => {
    let valid = true;
    const nextState = {};
    if (!firstName) {
      nextState.firstName = 'Required';
      valid = false;
    }
    if (!lastName) {
      nextState.lastName = 'Required';
      valid = false;
    }
    if (!gender) {
      nextState.gender = 'Required';
      valid = false;
    }
    if (!email && !patient.isDependent) {
      nextState.email = 'Required';
      valid = false;
    } else if (!EmailValidator.validate(email)) {
      nextState.email = 'Must be a valid email';
      valid = false;
    } else if (!emailError) {
      nextState.email = 'this email is already in use';
      valid = false;
    }
    if (!phone && !patient.isDependent) {
      nextState.phone = 'Required';
      valid = false;
    } else if (phone && !validatePhone(phone) && !patient.isDependent) {
      nextState.phone = 'Must be a valid phone number';
      valid = false;
    }
    if (!zipcode
      // && !patient.isDependent
    ) {
      nextState.zipcode = 'Required';
      valid = false;
    } else if (
      !zipcode.match(/^\d{5}$|^\d{5}-\d{4}$/) 
      // && !patient.isDependent
    ) {
      nextState.zipcode = 'Must be a valid zipcode';
      valid = false;
    }
    let selectedDate = new Date(birthdate); //dd-mm-YYYY
    let currentDate = new Date();
    let minDate = new Date('01-01-1920');
    if (!birthdate) {
      nextState.birthdate = 'Required';
      valid = false;
    } else if (moment.utc(birthdate).format('YYYY-MM-DD') === 'Invalid date') {
      nextState.birthdate = 'Invalid Date';
      valid = false;
    } else if (selectedDate >= currentDate) {
      nextState.birthdate = 'Future Date not allowed';
      valid = false;
    } else if (selectedDate <= minDate) {
      nextState.birthdate = 'Invalid Date';
      valid = false;
    }
    if (!addressLine1?.trim()) {
      valid = false;
      nextState.addressLine1 = 'Required';
    }
    if (!city?.trim()) {
      valid = false;
      nextState.city = 'Required';
    }
    if (!state?.trim()) {
      valid = false;
      nextState.state = 'Required';
    } else if (!state.match(/^[A-Z]{2}$/)) {
      valid = false;
      nextState.state = 'Must be a valid 2-letter state code';
    }
    if (!insurancePlanId) {
      valid = false;
      nextState.insurancePlanId = 'Required';
    }
    if (!insuranceId?.trim()) {
      valid = false;
      nextState.insuranceId = 'Required';
    }
    // For Medicare insurance group number is not required.
    if (!groupNumber?.trim()  && !insuranceWithoutGroupNumber?.includes(insurancePlanId)) {
      valid = false;
      nextState.groupNumber = 'Required';
    }
    setValidationErrors(nextState);
    return valid;
  };

  const onChange = setter => event => {
    const value =
      event.target.name === 'state'
        ? event.target.value.toUpperCase().slice(0, 2)
        : event.target.value;
    setter(value);
    setValidationErrors({ ...validationErrors, [event.target.name]: false });
  };

  return (
    <Dialog
      // disableBackdropClick
      open
      fullWidth
      onClose={onClose}
      maxWidth={'xs'}
    >
      <DialogTitle>Update Your Profile</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="First Name"
          value={firstName}
          variant="outlined"
          name="firstName"
          onChange={onChange(setFirstName)}
          error={validationErrors.firstName}
          helperText={validationErrors.firstName}
          className={input}
        />

        <TextField
          fullWidth
          label="Last Name"
          value={lastName}
          variant="outlined"
          name="lastName"
          onChange={onChange(setLastName)}
          error={validationErrors.lastName}
          helperText={validationErrors.lastName}
          className={input}
        />

        <TextField
          fullWidth
          label="Preferred Name"
          value={preferredName}
          variant="outlined"
          name="preferredName"
          onChange={onChange(setPreferredName)}
          error={validationErrors.preferredName}
          helperText={validationErrors.preferredName}
          className={input}
        />

        {!patient.isDependent && (
          <>
            <TextField
              fullWidth
              label="Email"
              value={email}
              variant="outlined"
              name="email"
              onChange={event => {
                setEmail(event.target.value);
                setValidationErrors({
                  ...validationErrors,
                  [event.target.name]: false,
                });
              }}
              error={validationErrors.email}
              helperText={validationErrors.email}
              inputProps={{
                onBlur: async () => {
                  const available = await isEmailAvailable(email);
                  setEmailError(available);
                  if (!available) {
                    setValidationErrors({
                      ...validationErrors,
                      email: 'this email is already in use',
                    });
                  }
                },
              }}
              className={input}
            />
            <TextField
              fullWidth
              label="Phone Number"
              value={phone}
              variant="outlined"
              name="phone"
              onChange={onChange(setPhone)}
              error={validationErrors.phone}
              helperText={validationErrors.phone}
              className={input}
              InputProps={{
                inputComponent: PhoneInput,
              }}
            />
          </>
        )}

        <TextField
          fullWidth
          label="Address Line 1"
          value={addressLine1}
          name="addressLine1"
          variant="outlined"
          onChange={onChange(setAddressLine1)}
          error={!!validationErrors.addressLine1}
          helperText={validationErrors.addressLine1}
          className={input}
        />

        <TextField
          fullWidth
          label="Address Line 2"
          value={addressLine2}
          name="addressLine2"
          variant="outlined"
          onChange={onChange(setAddressLine2)}
          error={validationErrors.addressLine2}
          helperText={validationErrors.addressLine2}
          className={input}
        />

        <TextField
          fullWidth
          label="City"
          value={city}
          name="city"
          variant="outlined"
          onChange={onChange(setCity)}
          error={!!validationErrors.city}
          helperText={validationErrors.city}
          className={input}
        />

        <Autocomplete
          options={STATES_LIST}
          getOptionLabel={option =>
            option ? `${option.code} - ${option.name}` : ''
          }
          value={STATES_LIST.find(option => option.code === state) || null}
          onChange={(_, value) => {
            setState(value?.code || '');
            setValidationErrors(prev => ({
              ...prev,
              state: false,
            }));
          }}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              label="State"
              name="state"
              variant="outlined"
              error={!!validationErrors.state}
              helperText={validationErrors.state}
              className={input}
            />
          )}
        />

        <TextField
          fullWidth
          label="Zipcode"
          value={zipcode}
          variant="outlined"
          name="zipcode"
          onChange={onChange(setZipcode)}
          error={validationErrors.zipcode}
          helperText={validationErrors.zipcode}
          className={input}
        />

        <Autocomplete
          options={insurancePlans}
          getOptionLabel={option =>
            option ? `${option.companyName} - ${option.planName} (${option.payerId})` : ''
          }
          filterOptions={(options, { inputValue }) => {
            const searchValue = inputValue.toLowerCase();

            return options.filter(
              option =>
                option.companyName?.toLowerCase().includes(searchValue) ||
                option.planName?.toLowerCase().includes(searchValue) ||
                option.payerId?.toLowerCase().includes(searchValue)
            );
          }}
          value={
            insurancePlans.find(item => item.id === insurancePlanId) || null
          }
          onChange={(event, selectedPlan) => {
            setInsurancePlanId(selectedPlan?.id || null);
            setPayerId(selectedPlan?.payerId || '');

            setValidationErrors(prev => ({
              ...prev,
              insurancePlanId: false,
            }));
          }}
          className={input}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              label="Insurance Name / Payer ID"
              variant="outlined"
              error={!!validationErrors.insurancePlanId}
              helperText={validationErrors.insurancePlanId}
            />
          )}
        />

        <TextField
          fullWidth
          InputProps={{
            readOnly: true,
            disabled: true
          }}
          label="Payer ID"
          value={payerId}
          variant="outlined"
          name="payerId"
          onChange={onChange(setPayerId)}
          error={!!validationErrors.payerId}
          helperText={validationErrors.payerId}
          className={input}
        />

        <TextField
          fullWidth
          label="Insurance ID"
          value={insuranceId}
          variant="outlined"
          name="insuranceId"
          onChange={onChange(setInsuranceId)}
          error={!!validationErrors.insuranceId}
          helperText={validationErrors.insuranceId}
          className={input}
        />

    {!insuranceWithoutGroupNumber?.includes(insurancePlanId) && <TextField
          fullWidth
          label="Group Number"
          value={groupNumber}
          variant="outlined"
          name="groupNumber"
          onChange={onChange(setGroupNumber)}
          error={!!validationErrors.groupNumber}
          helperText={validationErrors.groupNumber}
          className={input}
        />}

        <FormControl component="fieldset" variant="filled" className={input}>
          <FormLabel component="legend">Gender</FormLabel>
          <RadioGroup
            row
            aria-label="Gender"
            name="gender"
            value={gender}
            onChange={event => setGender(event.target.value)}
          >
            <FormControlLabel
              value="female"
              control={<Radio />}
              label="Female"
            />
            <FormControlLabel value="male" control={<Radio />} label="Male" />
          </RadioGroup>
        </FormControl>

        <DateSelect
          disableFuture
          format="MM/DD/YYYY"
          value={new Date(birthdate)}
          maxDate={moment()}
          minDate={new Date('01-01-1920')}
          label="Birthdate"
          onChange={date => {
            setBirthdate(date);
            setValidationErrors({ ...validationErrors, birthdate: false });
          }}
          error={validationErrors.birthdate}
          helperText={validationErrors.birthdate}
          className={input}
        />

        {/* {isSubscribed ? (
          <Button
            onClick={() => {
              cancelSubscriptions();
              setIsSubscribed(false);
            }}
          >
            cancel qwell concierge subscription
          </Button>
        ) : (
          <Button>
            <Link
              href={process.env.REACT_APP_HOMEPAGE_URL + '/concierge-pricing'}
              target="_blank"
            >
              sign up for qwell concierge
            </Link>
          </Button>
        )} */}
      </DialogContent>

      <DialogActions className={dialogFooter}>
        <Button onClick={onClose} color="primary" variant="outlined">
          Back
        </Button>
        <div>
          <button
            type="button"
            onClick={e => onSubmit(e)}
            className="save-btn-custom"
            disabled={buttonDisable}
          >
            Save
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

PortalProfileUpdate.propTypes = {
  patient: PropTypes.object,
  updatePatient: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  input: {
    margin: '0.5rem 0',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
});

export default withStyles(styles)(PortalProfileUpdate);
